import { render, staticRenderFns } from "./InsCourse.vue?vue&type=template&id=b37c35d6&scoped=true&"
import script from "./InsCourse.vue?vue&type=script&lang=js&"
export * from "./InsCourse.vue?vue&type=script&lang=js&"
import style0 from "./InsCourse.vue?vue&type=style&index=0&id=b37c35d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37c35d6",
  null
  
)

export default component.exports